import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

const TablePagination = ({ totalPages = 1, currentPage = 1, pageUrl = "" }) => {
  const location = useLocation();
  const [buttonOut, setButtonOut] = useState([]);

  const history = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }

  useEffect(() => {
    let startPage = Math.max(1, currentPage - 2);
    let lastPage = Math.min(startPage + 4, totalPages); 
  
    const renderedItems = [];
    for (let i = startPage; i <= lastPage; i++) {
      renderedItems.push(
        <PaginationItem className={i === currentPage ? "active" : ""} key={`pageNo${i}`}>
          <PaginationLink onClick={() => handlePageChange(i)}>
            {i}
          </PaginationLink>
        </PaginationItem>
      );
    }
    setButtonOut(renderedItems);
  }, [currentPage, totalPages]);

  const handlePageChange = (curPage) => {
    parameters.page = curPage;
    const queryString = new URLSearchParams(parameters).toString();
    history(`${pageUrl}${queryString}`);
  };
  return (
    <>
      <nav aria-label="...">
        <Pagination
          className="pagination justify-content-end mb-0"
          listClassName="justify-content-end mb-0"
        >
          {currentPage !== 1 && (
            <>
              <PaginationItem className="" key="prevKey">
                <PaginationLink
                  onClick={() => handlePageChange(currentPage - 1)}
                  tabIndex="-1"
                >
                  <i className="fas fa-angle-left" />
                  <span className="sr-only">Previous</span>
                </PaginationLink>
              </PaginationItem>
            </>

          )}
          {buttonOut}
          {currentPage !== totalPages && (
            <>
              <PaginationItem key="nextKey">
                <PaginationLink
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  <i className="fas fa-angle-right" />
                  <span className="sr-only">Next</span>
                </PaginationLink>
              </PaginationItem>
            </>
          )}
        </Pagination>
      </nav>
    </>
  );
};

export default TablePagination;